import { CircularProgress } from 'material-ui';
import * as React from 'react';

import { setLoading, setSuccess } from '../../actions/loadingActions';
import { PlantModel } from '../../model/PlantModel';
import { sendReminder } from '../../services/dashboardService';
import { getCurrentUserAccessLevel } from '../../utils/generalUtils';
import { Async } from '../reusableComponents/Async';

export interface IPlantListItemProps {
    index: number;
    plantId: string;
    onClick(plantID): void;
    formType: string;
    isCompleted: boolean;
}

export class PlantListItem extends React.PureComponent<IPlantListItemProps, {}> {

    static defaultProps: IPlantListItemProps;

    handleReminderClick = () => {
        const { index, plantId, formType } = this.props;
        this.props.onClick(plantId);
    }

    handleSendReminder = async () => {
        const { index, plantId, formType } = this.props;
        const plantInstance = PlantModel.getBy('PlantId', plantId);
        setLoading(`ReminderButton${index}`);
        await sendReminder(plantInstance.props.id, formType, null);
        setSuccess(`ReminderButton${index}`);
    }

    render() {
        const { index, plantId, formType } = this.props;
        return < div className="modal-list-item"  >
            <div onClick={this.handleReminderClick} className="serial-no" >{index + 1}</div>
            <div onClick={this.handleReminderClick} className="plant-id" >{plantId}</div>
            {getCurrentUserAccessLevel() === 'L1' || getCurrentUserAccessLevel() === 'L2' ?
                !this.props.isCompleted ? <div className="reminder-button" >
                    <button onClick={this.handleSendReminder} >
                        <Async
                            identifier={`ReminderButton${index}`}
                            promise={() => setSuccess(`ReminderButton${index}`)}
                            loader={<CircularProgress style={buttonStyle} color="white" ></CircularProgress>}
                            content={<span>Send Reminder</span>}
                            error={<div>Please Try Again</div>}
                        />
                    </button>
                </div> :
                    <div onClick={this.handleReminderClick} className="reminder-button" >
                        Completed
                </div> :
                <div onClick={this.handleReminderClick} className="reminder-button" >
                    NA
                </div>}
        </div >;
    }
}

const buttonStyle: React.CSSProperties = {
    width: '116.48px',
    height: '20px',
    display: 'flex',
    justifyContent: 'center'
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Dashboard/PlantListItem.tsx